export default __webpack_public_path__ + "0080fd2f44ff07e45cdb04aafc4174e1.gif";